import { push } from 'connected-react-router'
import Popup from 'react-popup'
import {
  GET_PRODUCTIONS,
  GET_OPERATIONS,
  GET_OPERATION,
  SET_OPERATION_STATE,
  GET_STOP_REASONS,
  RETURN_TO_PRODUCTIONS,
  RETURN_TO_OPERATIONS,
  LOGOUT_USER,
  API_ERROR
} from '../constants/ActionTypes'
import Odoo from '../utils/Odoo'

export function api_error(dispatch, e) {
  if (e && e.status === 403) {
    Popup.alert('Sesja wygasła, zaloguj się ponownie.')
    dispatch({ type: LOGOUT_USER })
  } else {
    Popup.alert((e && e.message) || 'Wystąpił nieznany błąd')
    dispatch({ type: API_ERROR, message: e && e.message })
  }
}

export function getProductions() {
  return dispatch => {
    Odoo.call('production/get_productions').then(res => {
      dispatch({ type: GET_PRODUCTIONS, payload: res })
    }).catch(error => api_error(dispatch, error))
  }
}

export function getOperations(production_id) {
  return dispatch => {
    Odoo.call('production/get_operations', { production_id }).then(res => {
      dispatch({ type: GET_OPERATIONS, payload: res })
    }).catch(error => api_error(dispatch, error))
  }
}

export function selectProduction(production_id) {
  return dispatch => {
    Odoo.call('production/get_operations', { production_id }).then(res => {
      dispatch({ type: GET_OPERATIONS, payload: res })
      dispatch(push({ search: `?production=${production_id}` }))
    }).catch(error => api_error(dispatch, error))
  }
}

export function getOperation(id) {
  return dispatch => {
    Odoo.call('production/get_operation', { id }).then(res => {
      dispatch({ type: GET_OPERATION, payload: res })
    }).catch(error => api_error(dispatch, error))
  }
}

export function selectOperation(id) {
  return dispatch => {
    Odoo.call('production/get_operation', { id }).then(res => {
      dispatch({ type: GET_OPERATION, payload: res })
      dispatch(push({ search: `?operation=${id}` }))
    }).catch(error => api_error(dispatch, error))
  }
}

export function startOperation(id) {
  return dispatch => {
    Odoo.call('production/start_operation', { id }).then(res => {
      dispatch({ type: SET_OPERATION_STATE, payload: res })
    }).catch(error => api_error(dispatch, error))
  }
}

export function getStopReasons(event_type) {
  return dispatch => {
    Odoo.call('production/get_stop_reasons', { event_type }).then(res => {
      dispatch({ type: GET_STOP_REASONS, payload: { event_type, reasons: res } })
    }).catch(error => api_error(dispatch, error))
  }
}

export function pauseOperation(id, loss_id, note) {
  return dispatch => {
    Odoo.call('production/pause_operation', { id, loss_id, note }).then(res => {
      dispatch({ type: SET_OPERATION_STATE, payload: res })
    }).catch(error => api_error(dispatch, error))
  }
}

export function reportFailure(id, loss_id, note) {
  return dispatch => {
    Odoo.call('production/report_failure', { id, loss_id, note }).then(res => {
      dispatch({ type: SET_OPERATION_STATE, payload: res })
    }).catch(error => api_error(dispatch, error))
  }
}

export function resumeOperation(id) {
  return dispatch => {
    Odoo.call('production/resume_operation', { id }).then(res => {
      dispatch({ type: SET_OPERATION_STATE, payload: res })
    }).catch(error => api_error(dispatch, error))
  }
}

export function finishOperation(id, qty_produced, qty_waste, lot_name) {
  return dispatch => {
    const params = { id, qty_produced, qty_waste }
    if (lot_name) {
      params.lot_name = lot_name
    }
    return Odoo.call('production/finish_operation', params).then(res => {
      dispatch({ type: SET_OPERATION_STATE, payload: res })
      return res
    }).catch(error => {
      api_error(dispatch, error)
      throw error
    })
  }
}

export function returnToProductions() {
  return dispatch => {
    dispatch({ type: RETURN_TO_PRODUCTIONS })
    dispatch(push({ search: '' }))
  }
}

export function returnToOperations(production_id) {
  return dispatch => {
    dispatch({ type: RETURN_TO_OPERATIONS })
    dispatch(push({ search: `?production=${production_id}` }))
    Odoo.call('production/get_operations', { production_id }).then(res => {
      dispatch({ type: GET_OPERATIONS, payload: res })
    }).catch(error => api_error(dispatch, error))
  }
}
